import { LocalNotificationSchema } from '@capacitor/local-notifications';

export enum NotificationType {
  'Action' = 'ActionNotification',
  'App' = 'AppNotification',
  'Measurement' = 'MeasurementNotification',
  'Medication' = 'MedicationIntakeNotification',
  'Survey' = 'SurveyNotification',
  'Subscription' = 'SubscriptionNotification',
  'Custom' = 'CustomNotification',
  'Daily' = 'DailyNotification',
}

export type ILocalNotificationType = Omit<LocalNotificationSchema, 'id'>;
